import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';
import { stylesPropType, vmPropTypes } from '../../global-prop-types';

const Video = (props) => {
  const {
    src, autoPlay, poster, muted, styles
  } = props;
  
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && autoPlay && src) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log('Auto-play was prevented:', error);
        });
      }
    }
  }, [autoPlay, src, videoRef.current]);

  if (!src) return null;
  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video 
      poster={poster && poster?.trim() !== "" ? poster : undefined}
      ref={videoRef}
      src={src} 
      style={styles?.wrapper} 
      width="100%" 
      height="100%" 
      controlsList="nodownload" 
      controls 
      muted={muted} 
    />
  );
};

Video.propTypes = {
  styles: stylesPropType,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool,
  src: PropTypes.string,
  poster: PropTypes.string
};

Video.defaultProps = {
  styles: {
    wrapper: { }
  },
  src: '',
  autoPlay: false,
  muted: false
};

Video.vmPropTypes = {
  styles: { wrapper: vmPropTypes.styles },
  src: vmPropTypes.string,
  poster: vmPropTypes.string,
  autoPlay: vmPropTypes.boolean,
  muted: vmPropTypes.boolean
};

export default Video;
